import { countdown } from '../countdown';

const OLYMPIC_GAMES_START_DATE = new Date('2026-02-06T00:00:00');

export const countdownBar = () => {
countdown(OLYMPIC_GAMES_START_DATE);

const countdownBarEl = document.querySelector('.countdown_bar');
const closeBtn = document.querySelector('.countdown_bar__close');

closeBtn.addEventListener('click', () => {
  countdownBarEl.classList.add('countdown_bar_hidden');
})

}